// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1P-o3","errorLogs":"EditorFooter_errorLogs__3xDPV"};